<template>
    <project-step-container
            prev-to="js_deep_customer_empathy_3"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <b-row>
            <b-col cols="12" class="main-text" tabindex="0" >
                {{getMessage(4, 'empathy-map-sub')}}
            </b-col>
        </b-row>

        <upload-image :project-id="projectId" :step="step" />
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(4, 'firstThing')}}</label>
                <input id="first-thing" type="text" v-model="form.firstThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(4, 'secondThing')}}</label>
                <input id="second-thing" type="text" v-model="form.secondThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(4, 'thirdThing')}}</label>
                <input id="third-thing" type="text" v-model="form.thirdThing"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import UploadImage from "../../../core/Components/UploadImage"
    import Steps from "../Utils/steps";

    export default {
        name: "DeepCustomerEmpathy4",
        components: {ProjectStepContainer, UploadImage},
        data() {
            return {
                step: Steps.FORM_SKETCH,
                projectId: Storage.getProjectId(this.$route.params.index),
                urlNextProject:'js_deep_customer_empathy_5',
                form: {
                    sketch: "",
                    firstThing: "",
                    secondThing: "",
                    thirdThing: ""
                },
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>
